/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum PrestatieanalyseVSOUitzondering {
    TELT_MEE_VOOR_PRESTATIEANALYSE = "Telt mee voor prestatieanalyse",
    MINDER_DAN_6_WEKEN_INGESCHREVEN = "Minder dan 6 weken ingeschreven"
}
